import React from "react";

function ReporteMaquinaria({ datos }) {
  if (!datos) return <p>No hay reporte para mostrar.</p>;

  return (
    <div style={containerStyle}>
      {/* Fecha y Número */}
      <div style={filaFechaNumero}>
        <div style={fechaText}><strong>FECHA:</strong> __ / __ / __</div>
        <div style={numeroText}><strong>N°:</strong> {datos.numero || "____"}</div>
      </div>

      {/* Encabezado Empresa */}
      <div style={encabezadoStyle}>
        <img src="/movimonte-logo.png" alt="Logo" style={logoStyle} />
        <div style={infoEmpresaStyle}>
          <h2 style={tituloEmpresa}>MOVIMONTE SPA</h2>
          <p style={textoSub}>Transporte de carga, movimiento de tierra y compra y venta de áridos</p>
          <p style={textoNormal}>📍 Domingo Santa María #191, El Monte</p>
          <p style={textoNormal}>✉️ andre_323@live.com | ventas@movimonte.com</p>
          <p style={textoNormal}>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              style={{ width: "14px", verticalAlign: "middle", marginRight: "6px" }}
            />
            +56957020163 - +56968311079
          </p>
        </div>
      </div>

      {/* Datos de la Máquina */}
      <div style={datosFila}>
        <div style={datoItem}>
          <strong>EMPRESA:</strong> <span style={lineaTexto}>{datos.empresa || ""}</span>
        </div>
        <div style={datoItem}>
          <strong>SIGLA:</strong> <span style={lineaTexto}>{datos.sigla || ""}</span>
        </div>
      </div>
      <div style={datosFila}>
        <div style={datoItem}>
          <strong>MÁQUINA:</strong> <span style={lineaTexto}>{datos.maquina || ""}</span>
        </div>
        <div style={datoItem}>
          <strong>OBRA:</strong> <span style={lineaTexto}>{datos.obra || ""}</span>
        </div>
      </div>
      <div style={datoItem}>
        <strong>OPERADOR:</strong> <span style={lineaTexto}>{datos.operador || ""}</span>
      </div>

      {/* Horario de operación */}
      <h4 style={seccion}>HORARIO DE OPERACIÓN</h4>
      <table style={tabla}>
        <thead>
          <tr>
            <th style={headerCell}>INICIO</th>
            <th style={headerCell}>TÉRMINO</th>
            <th style={headerCell}>TOTAL HORAS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={cell}>{datos.horaInicio}</td>
            <td style={cell}>{datos.horaTermino}</td>
            <td style={cell}>{datos.diferencia}</td>
          </tr>
        </tbody>
      </table>

      {/* Control Diario de Niveles */}
      <h4 style={seccion}>CONTROL DIARIO DE NIVELES</h4>
      <table style={tabla}>
        <tbody>
          <tr>
            <td style={cell}>Combustibles</td>
            <td style={cell}>{datos.combustibles} Lts.</td>
            <td style={cell}>Diferencial</td>
            <td style={cell}>{datos.diferencial} Lts.</td>
          </tr>
          <tr>
            <td style={cell}>Aceite Motor</td>
            <td style={cell}>{datos.aceiteMotor} Lts.</td>
            <td style={cell}>Engrase</td>
            <td style={cell}>{datos.engrase} Lts.</td>
          </tr>
          <tr>
            <td style={cell}>Aceite Caja</td>
            <td style={cell}>{datos.aceiteCaja} Lts.</td>
            <td style={cell}></td>
            <td style={cell}></td>
          </tr>
          <tr>
            <td style={cell}>Aceite Hidráulico</td>
            <td style={cell}>{datos.aceiteHidraulico} Lts.</td>
            <td style={cell}></td>
            <td style={cell}></td>
          </tr>
        </tbody>
      </table>

      {/* Reparaciones */}
      <h4 style={seccion}>REPARACIONES PENDIENTES</h4>
      <div style={lineasEntrada}></div>
      <div style={lineasEntrada}></div>

      {/* Trabajos */}
      <h4 style={seccion}>TRABAJOS REALIZADOS</h4>
      <div style={lineasEntrada}></div>
      <div style={lineasEntrada}></div>
      <div style={lineasEntrada}></div>

      {/* Firmas */}
      <div style={firmasStyle}>
        <div style={firmaBox}>
          <div style={firmaLinea}></div>
          <p>V° B° ING.</p>
        </div>
        <div style={firmaBox}>
          <div style={firmaLinea}></div>
          <p>V° B° JEFE OBRA</p>
        </div>
        <div style={firmaBox}>
          <div style={firmaLinea}></div>
          <p>FIRMA OPERADOR</p>
        </div>
      </div>
    </div>
  );
}

// === ESTILOS ===
const containerStyle = {
  width: "13.5cm",
  minHeight: "20cm",
  padding: "20px",
  border: "1px solid #000",
  backgroundColor: "#fff",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  fontSize: "12px",
  color: "#222",
};

const filaFechaNumero = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "6px",
};

const fechaText = {
  fontWeight: "bold",
};

const numeroText = {
  fontWeight: "bold",
};

const encabezadoStyle = {
  display: "flex",
  gap: "20px",
  alignItems: "center",
  marginBottom: "10px",
};

const logoStyle = {
  width: "70px",
};

const infoEmpresaStyle = {
  flex: 1,
  lineHeight: "1.4",
};

const tituloEmpresa = {
  margin: 0,
  fontSize: "18px",
  fontWeight: "700",
  color: "#ff0000ff",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const textoSub = {
  margin: "3px 0",
  fontSize: "12px",
  color: "#555",
  fontStyle: "italic",
};

const textoNormal = {
  margin: "2px 0",
  fontSize: "12px",
};

const datosFila = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "4px",
};

const datoItem = {
  flexBasis: "48%", // para mantener las columnas pares balanceadas
  fontWeight: "bold",
  fontSize: "12px",
  marginBottom: "2px",
};

const lineaTexto = {
  display: "inline-block",
  borderBottom: "1px solid #000",
  minWidth: "200px", // LÍNEA MÁS LARGA
  marginLeft: "4px",
  fontWeight: "normal",
};

const seccion = {
  marginTop: "10px",
  marginBottom: "4px",
  fontWeight: "bold",
  textTransform: "uppercase",
};

const tabla = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "12px",
};

const headerCell = {
  border: "1px solid #000",
  padding: "4px",
  fontWeight: "bold",
  backgroundColor: "#f2f2f2",
};

const cell = {
  border: "1px solid #000",
  padding: "4px",
  textAlign: "center",
};

const lineasEntrada = {
  borderBottom: "1px solid #000",
  minHeight: "18px",
  marginBottom: "6px",
};

const firmasStyle = {
  display: "flex",
  justifyContent: "space-around",
  marginTop: "40px",
  flexWrap: "wrap", // ✅ evita que se desborde
};

const firmaBox = {
  textAlign: "center",
  width: "30%", // ✅ asegura que no se pase del contenedor
};

const firmaLinea = {
  borderBottom: "1px solid #000",
  width: "100%",
  height: "30px",
  marginBottom: "5px",
};


export default ReporteMaquinaria;
